(function () {
  let activeWarrantyModal = null;
  let warrantyTrigger = null;

  function openWarrantyModal(button) {
    const modalId = button.getAttribute('data-cl-warranty-open');

    let modal = document.querySelector(
      `body > #${modalId}.cl-warranty-modal`
    );

    if (!modal) {
      modal = document.getElementById(modalId);

      if (!modal) return;

      /*
       * Move the modal directly below <body>.
       * This avoids Dawn/product/card stacking contexts.
       */
      document.body.appendChild(modal);
    }

    /*
     * Remove duplicates if Shopify rerendered a section.
     */
    document
      .querySelectorAll(`#${modalId}.cl-warranty-modal`)
      .forEach(function (otherModal) {
        if (otherModal !== modal) {
          otherModal.remove();
        }
      });

    warrantyTrigger = button;
    activeWarrantyModal = modal;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('cl-warranty-open');
    document.body.classList.add('cl-warranty-open');

    const closeButton = modal.querySelector(
      '.cl-warranty-modal__close'
    );

    if (closeButton) {
      setTimeout(function () {
        closeButton.focus();
      }, 10);
    }
  }

  function closeWarrantyModal() {
    if (!activeWarrantyModal) return;

    activeWarrantyModal.classList.remove('is-open');
    activeWarrantyModal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('cl-warranty-open');
    document.body.classList.remove('cl-warranty-open');

    if (
      warrantyTrigger &&
      typeof warrantyTrigger.focus === 'function'
    ) {
      warrantyTrigger.focus();
    }

    activeWarrantyModal = null;
    warrantyTrigger = null;
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest(
      '[data-cl-warranty-open]'
    );

    if (openButton) {
      event.preventDefault();
      openWarrantyModal(openButton);
      return;
    }

    const closeButton = event.target.closest(
      '[data-cl-warranty-close]'
    );

    if (closeButton) {
      event.preventDefault();
      closeWarrantyModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      activeWarrantyModal
    ) {
      closeWarrantyModal();
    }
  });
})();